import React, { isValidElement, ReactNode } from "react";
import Card from "@mui/material/Card";
import { Box, CardHeader, SxProps } from "@mui/material";
import Link from "@mui/material/Link";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";

interface AppCardProps {
  sxStyle?: SxProps;
  title?: string | ReactNode;
  titleStyle?: SxProps;
  contentStyle?: SxProps;
  headerStyle?: SxProps;
  action?: ReactNode;
  footer?: ReactNode;
  footerPosition?: string;
  footerStyle?: SxProps;
  children: ReactNode;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [x: string]: any;
}

const AppCard: React.FC<AppCardProps> = ({
  sxStyle,
  title = "",
  titleStyle,
  headerStyle,
  contentStyle,
  action,
  footer,
  footerPosition = "left",
  footerStyle,
  children,
  ...rest
}) => {
  return (
    <Card
      sx={{ display: "flex", flexDirection: "column", ...sxStyle }}
      {...rest}
    >
      {title || action ? (
        <CardHeader
          sx={{
            px: 0,
            py: 0,
            pb: 0,
            margin: 0,
            height: "48px",
            "& .MuiCardHeader-action": {
              marginTop: 0,
              marginRight: 0,
            },
            "& .MuiCardHeader-content": {
              overflow: "hidden",
            },
            ...headerStyle,
          }}
          title={
            typeof title === "object" ? (
              title
            ) : (
              <Box
                component="h3"
                sx={{
                  color: "text.primary",
                  fontWeight: 600,
                  fontSize: 16,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  width: "100%",
                  margin: 0,
                  px: 2,
                  ...titleStyle,
                }}
              >
                {title}
              </Box>
            )
          }
          action={action}
        />
      ) : null}
      <CardContent
        sx={{
          height: "100%",
          px: 1,
          py: 0,
          "&:last-of-type": {
            pb: 0,
          },
          ...contentStyle,
        }}
      >
        {children}
      </CardContent>
      {footer ? (
        <CardActions
          sx={{
            px: 6,
            pb: 4,
            ...footerStyle,
          }}
        >
          {isValidElement(footer) ? (
            footer
          ) : (
            <Box
              component="span"
              sx={{ ml: footerPosition === "right" ? "auto" : 0 }}
            >
              <Link
                color="secondary"
                component="button"
                underline="none"
                sx={{
                  fontSize: 14,
                  fontWeight: 500,
                }}
              >
                {footer}
              </Link>
            </Box>
          )}
        </CardActions>
      ) : null}
    </Card>
  );
};

export default AppCard;
